<div *transloco="let t" class="apple-father">
  <div class="apple-middle">
    <img
      class="apple-button"
      src="assets/images/appleid_button@2x.png"
      alt="Placeholder"
      (click)="login()" />
  </div>
</div>
